import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewProgramHeaderWrapper = styled.div`
  margin: 4px 0px;

  .header-left {
    ${responsive.MOBILE`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
  }
  .header-right {
    text-align: end;
    margin-top: 16px;
    flex: 1;

    ${responsive.SMALL_LAPTOP`
      flex-basis: 100%;
      margin-bottom: 16px;
      margin-top: 0;
     `}

    .header-right-button {
      ${responsive.MOBILE`
        width:100%;
        margin-bottom: 16px;
      `}
    }

    .header-center-button {
      margin: 0 8px;
      ${responsive.MOBILE`
        width:100%;
        margin-bottom: 16px;
        margin-left: 0px;
      `}
    }

    .version-history {
      min-width: 130px;
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}

      .form-header-right {
        width: 100%;

        .item-text {
          color: ${COLORS.cirrus_black};
        }
      }
    }
    .more-btn {
      display: inline-block;
      margin-left: 08px;
    }

    .MuiPaper-rounded {
      border-radius: 4px;
      border: 1px solid ${COLORS.cirrus_black5};
    }
  }
`;
